
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M39.786.813H4.292a4.243 4.243 0 00-2.98 1.221A4.138 4.138 0 00.078 4.988V23h39.707c1.118 0 2.19-.44 2.98-1.223A4.156 4.156 0 0044 18.825V4.988a4.137 4.137 0 00-1.233-2.954A4.214 4.214 0 0039.786.813z","fill":"#000"}}),_c('path',{attrs:{"d":"M10.27 16.706c-2.672 0-4.627-2.114-4.627-4.9 0-2.784 1.96-4.704 4.628-4.704h5.158v1.284h-5.158c-1.92 0-3.337 1.426-3.337 3.487s1.404 3.53 3.337 3.53h5.158v1.28l-5.158.023zM16.934 16.706v-1.28h7.212c1.078 0 1.653-.622 1.653-1.518 0-.993-.588-1.497-1.653-1.497h-4.535c-1.746 0-2.824-1.147-2.824-2.679 0-1.531.998-2.648 2.851-2.648h6.922v1.284h-6.922a1.446 1.446 0 00-1.066.387 1.422 1.422 0 00-.448 1.032 1.41 1.41 0 00.449 1.033 1.439 1.439 0 001.065.386h4.521c1.88 0 2.878.927 2.878 2.737 0 1.571-.944 2.745-2.878 2.745l-7.225.018zM29.813 9.03v7.676H28.57V7.773c0-.49.268-.794.682-.794a.898.898 0 01.615.304l7.332 7.437V7.05h1.238v8.999c0 .485-.28.777-.655.777a.979.979 0 01-.663-.331L29.813 9.03z","fill":"#fff"}})])
          )
        }
      }
    